import React from "react";

import { LONG_TAP } from "../../constants/settings";

export default class Tap extends React.Component {
  constructor(...args) {
    super(...args);

    this.state = {
      timerId: 0,
      isDragging: false,
    };
    this.mouseDownX = 0;
    this.mouseDownY = 0;
  }

  onMouseDown = (e) => {
    const { long } = this.props;

    this.setState({
      isDragging: false,
    });

    const timerId = setTimeout(() => {
      if (!this.state.isDragging) {
        this.setState({
          timerId: 0,
        });

        if (typeof long == "function") {
          long(e.clientY, e.target);
        }
      }
    }, LONG_TAP);

    this.setState({
      timerId,
    });
  };

  onMouseMove = (e) => {
    const { timerId } = this.state;

    if (!timerId) {
      return;
    }

    const deltaX = Math.abs(e.clientX - this.mouseDownX);
    const deltaY = Math.abs(e.clientY - this.mouseDownY);

    if (deltaX > 5 || deltaY > 5) {
      clearTimeout(timerId);
      this.setState({
        timerId: 0,
        isDragging: true,
      });
    }
  };

  onMouseLeave = () => {
    const { timerId } = this.state;

    if (!timerId) {
      return;
    }

    clearTimeout(timerId);

    this.setState({
      timerId: 0,
    });
  };

  onMouseUp = (e) => {
    const { short } = this.props;
    const { timerId } = this.state;

    if (!timerId) {
      return;
    }

    clearTimeout(timerId);

    if (typeof short == "function") {
      short(e);
    }

    this.setState({
      timerId: 0,
      isDragging: false,
    });
  };

  handleDragStart = (e) => {
    this.mouseDownX = e.clientX;
    this.mouseDownY = e.clientY;

    this.setState({
      isDragging: true,
    });
    const { timerId } = this.state;
    if (timerId) {
      clearTimeout(timerId);
      this.setState({
        timerId: 0,
      });
    }

    if (this.props.onDragStart) {
      this.props.onDragStart(e);
    }
  };

  handleDragEnd = (e) => {
    this.setState({
      isDragging: false,
    });

    if (this.props.onDragEnd) {
      this.props.onDragEnd(e);
    }
  };

  render() {
    const { tag, children, className, onMouseMove, ...restProps } = this.props;

    const Tag = tag || "div";

    return (
      <Tag
        onMouseMove={(e) => {
          this.onMouseMove(e);

          if (onMouseMove) {
            onMouseMove(e);
          }
        }}
        style={this.props.style}
        className={className}
        onMouseDown={this.onMouseDown}
        onMouseUp={this.onMouseUp}
        onMouseLeave={this.onMouseLeave}
        onDragStart={this.handleDragStart}
        onDragEnd={this.handleDragEnd}
        {...restProps}
      >
        {children}
      </Tag>
    );
  }
}
